import { Component, OnInit, ViewChild } from '@angular/core';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';

import { catchError, of, tap } from 'rxjs';
import { Tc, TcPerfilUsuarioEnum, EnumSiNoTodos, TcExpanded } from '../../../core/_infrastructure/types/common';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { BuscadorSolicitudExService } from './buscador-solicitudEx.service';

import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ConfigurationService } from '../../../core/_infrastructure/classes/services/configuration.service';
import { SolicitudExItemResultsViewModel, FilterSearchingSolicitudExViewModel, SolicitudExItemViewModel } from './buscador-solicitudEx.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { EnumIdsTcEstadoSolicitudEx, EnumIdsTwTcSubTipoSolicitudEx } from '../../../_exportacion/solicitudes/types/enum';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { SolicitudExViewModel } from '../../solicitudes/datosbasicos/datosbasicosEx.types';
import { HttpParams } from '@angular/common/http';
import { Table } from 'primeng/table';
import { LaboratorioExService } from '../../solicitudes/laboratorio/laboratorioEx.service';

@Component({
    selector: 'app-buscador-solicitudex-list',
    templateUrl: './buscador-solicitudEx-list.component.html',
})
export class BuscadorSolicitudExListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultSolicitudesEx: SolicitudExItemResultsViewModel;
    listPais: Tc[];
    listTipoSolicitud: TcExpanded[];
    listProvincias: Tc[];
    listPuntoInspeccion: Tc[];
    listEstado: Tc[];
    listEstadoCF: Tc[];
    listResultadoEnvioMuestrasLaboratorioEx: Tc[];
    firstDayMonth: Date;
    lastDayMonth: Date;
    cols: any[];
    public isCollapsed = false;
    paisEspania = 0;

    EnabledCloned = false;

    habilitarNueva = true;
    habilitarComprobarEphytos = false;

    visibilitySpinner = false;
    visibilitySpinnerComprobarEphytos = false;
    flagSearchIsComprobarEphytos = false;

    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    constructor(
        public datepipe: DatePipe,
        private router: Router,
        private fb: FormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected navMenuService: NavMenuService,
        protected exceptionHandler: ExceptionManager,
        protected configurationService: ConfigurationService,
        private confirmationService: ConfirmationService,
        private buscadorsolicitudExService: BuscadorSolicitudExService,
        private laboratorioExService: LaboratorioExService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultSolicitudesEx = new SolicitudExItemResultsViewModel();
    }

    ngOnInit() {
        this.navMenuService.resetSolicitudData();

        this.habilitarNueva = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_EXPORTACION).Visible;
        this.habilitarComprobarEphytos = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.COMPROBAR_EPHYTOS).Visible;

        this.configurationService.getValue('SolicitudEx:EnabledCloned').subscribe(result => {
            this.EnabledCloned = JSON.parse(result);
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Image', header: '' },
            { field: 'Codigo', header: 'Nº Solicitud' },
            { field: 'RefSolicitante', header: 'Ref. Solicitante' },
            { field: 'NumeroCertificado', header: 'Nº Certif. Fito' },
            { field: 'FechaEnvio', header: 'Fecha' }, // | date:'dd/MM/yyyy'
            { field: 'HoraEnvio', header: 'Hora' }, // | date:'dd/MM/yyyy'
            { field: 'RazonSocial', header: 'Solicitante' },
            { field: 'NombrePuntoInspeccion', header: 'Punto Inspección' },
            { field: 'NombreCompletoInspector', header: 'Inspector' },
            { field: 'NombreExportador', header: 'Exportador' },
            { field: 'NombrePaisDestino', header: 'País Destino' },
            { field: 'Ubicacion', header: 'Ubicación PIF' },
            { field: 'FechaInspeccion', header: 'Fecha Inspección' },
            { field: 'HoraInspeccion', header: 'Hora Inspección' },
            //{ field: 'FormatoSolicitud', header: 'Formato' },
            { field: 'FechaFinalizacion', header: 'Fecha Decisión' },
            { field: 'TieneAlegacion', header: 'Tiene Alegaciones' },
            { field: 'IdEstado', header: 'IdEstado', display: 'none' },
            { field: 'IdEstadoCertificadoFitoEx', header: 'IdEstadoCF', display: 'none' },
            { field: 'IdResultadoEnvioMuestrasLaboratorioEx', header: 'IdResultadoEnvioMuestrasLaboratorioEx', display: 'none' },
            { field: 'DocumentalRealizada', header: 'Documental Realizada' },
            { field: 'IdentidadRealizada', header: 'Identidad Realizada' },
            { field: 'FisicaRealizada', header: 'Fisica Realizada' },
        ];

        this.globalService.getAllPaisesExpor().subscribe(res => {
            this.listPais = res;
        });
        this.globalService.getTipoSolicitudExporActivos().subscribe(res => {
            //emarti69 04/10/2024 No debe aparecer el tipo de solicitud "Anulación y Sustitución"
            this.listTipoSolicitud = res.filter(f => f.Codigo != 'AS');
        });
        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        let params = new HttpParams();
        if (this.buscadorsolicitudExService.currentFilterSolicitudEx.IdProvincia != null) {
            params = params.append('id', this.buscadorsolicitudExService.currentFilterSolicitudEx.IdProvincia!.toString());
            params = params.append('esimportacion', 'false');
            this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
                this.listPuntoInspeccion = res;
            });
        }

        this.globalService.getEstadoSolicitudExpor().subscribe(res => {
            this.listEstado = res;
        });
        this.globalService.getEstadoCertificadoFitoEx().subscribe(res => {
            this.listEstadoCF = res;
        });

        this.laboratorioExService.getResultadosMuestraLaboratorioEx().subscribe(res => {
            this.listResultadoEnvioMuestrasLaboratorioEx = res;
        });

        this.firstDayMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        let temp = new Date().getMonth() + 1;
        this.lastDayMonth = new Date(new Date(new Date().getFullYear(), temp, 1).getTime() - 0.001 * 60 * 60 * 24);

        this.form = this.fb.group({
            Codigo: '',
            IdEstadoSolicitud: null,
            IdEstadoCertificadoFitoEx: null,
            IdPaisDestino: null,
            IdTipoSolicitudEx: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            NombreExportador: '',
            RazonSocial: '',
            EsPapel: EnumSiNoTodos.TODOS,
            EsPrevia: EnumSiNoTodos.TODOS,
            TieneAlegacion: EnumSiNoTodos.TODOS,
            EsEphyto: EnumSiNoTodos.TODOS,
            RefSolicitante: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            NumeroCertificado: '',
            IdResultadoEnvioMuestrasLaboratorioEx: null,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            EsAtestacionFitosanitaria: EnumSiNoTodos.TODOS,
            AnulaYSustituye: EnumSiNoTodos.TODOS,
            DocumentalRealizada: EnumSiNoTodos.TODOS,
        });

        let config = this.getConfig();
        this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        if (
            this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaDesde == null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaHasta == null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdEstadoSolicitud != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdEstadoCertificadoFitoEx != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdPaisDestino != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdProvincia != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdPuntoInspeccion != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdTipoSolicitudEx != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.Codigo != '' ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.NumeroCertificado != '' ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.EsPrevia != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.TieneAlegacion != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.EsEphyto != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.EsPapel != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.NombreExportador != '' ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.RazonSocial != '' ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.RefSolicitante != '' ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.IdResultadoEnvioMuestrasLaboratorioEx != null ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.TieneEnvioDeMuestras != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaDesde!.toString() != this.firstDayMonth.toString() ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaHasta!.toString() != this.lastDayMonth.toString() ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.EsAtestacionFitosanitaria != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.AnulaYSustituye != EnumSiNoTodos.TODOS ||
            this.buscadorsolicitudExService.currentFilterSolicitudEx.DocumentalRealizada != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                IdEstadoSolicitud: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdEstadoSolicitud,
                IdEstadoCertificadoFitoEx: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdEstadoCertificadoFitoEx,
                IdPaisDestino: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdPaisDestino,
                IdProvincia: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdProvincia,
                IdPuntoInspeccion: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdPuntoInspeccion,
                IdTipoSolicitudEx: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdTipoSolicitudEx,
                Codigo: this.buscadorsolicitudExService.currentFilterSolicitudEx.Codigo,
                EsPrevia: this.buscadorsolicitudExService.currentFilterSolicitudEx.EsPrevia,
                TieneAlegacion: this.buscadorsolicitudExService.currentFilterSolicitudEx.TieneAlegacion,
                EsEphyto: this.buscadorsolicitudExService.currentFilterSolicitudEx.EsEphyto,
                EsPapel: this.buscadorsolicitudExService.currentFilterSolicitudEx.EsPapel,
                NombreImportador: this.buscadorsolicitudExService.currentFilterSolicitudEx.NombreExportador,
                RazonSocial: this.buscadorsolicitudExService.currentFilterSolicitudEx.RazonSocial,
                RefSolicitante: this.buscadorsolicitudExService.currentFilterSolicitudEx.RefSolicitante,
                IdResultadoEnvioMuestrasLaboratorioEx: this.buscadorsolicitudExService.currentFilterSolicitudEx.IdResultadoEnvioMuestrasLaboratorioEx,
                TieneEnvioDeMuestras: this.buscadorsolicitudExService.currentFilterSolicitudEx.TieneEnvioDeMuestras,
                FechaDesde: this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaDesde,
                FechaHasta: this.buscadorsolicitudExService.currentFilterSolicitudEx.FechaHasta,
                EsAtestacionFitosanitaria: this.buscadorsolicitudExService.currentFilterSolicitudEx.EsAtestacionFitosanitaria,
                AnulaYSustituye: this.buscadorsolicitudExService.currentFilterSolicitudEx.AnulaYSustituye,
                DocumentalRealizada: this.buscadorsolicitudExService.currentFilterSolicitudEx.DocumentalRealizada,
            });

            this.onSearchButton();
        }
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }
        this.Search(0);
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    CreateModel(): FilterSearchingSolicitudExViewModel {
        let model: FilterSearchingSolicitudExViewModel = new FilterSearchingSolicitudExViewModel();

        model.Codigo = this.form.value.Codigo;
        model.NumeroCertificado = this.form.value.NumeroCertificado;
        model.RefSolicitante = this.form.value.RefSolicitante;
        model.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        model.FechaDesde = this.form.value.FechaDesde;
        model.FechaHasta = this.form.value.FechaHasta;
        model.IdTipoSolicitudEx = this.form.value.IdTipoSolicitudEx;
        model.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        model.IdEstadoCertificadoFitoEx = this.form.value.IdEstadoCertificadoFitoEx;
        model.IdProvincia = this.form.value.IdProvincia;
        model.IdUsuario = this.loggedInUser!.Id;
        model.RazonSocial = this.form.value.RazonSocial;
        model.IdResultadoEnvioMuestrasLaboratorioEx = this.form.value.IdResultadoEnvioMuestrasLaboratorioEx;
        model.TieneEnvioDeMuestras = this.form.value.TieneEnvioDeMuestras;
        model.AnulaYSustituye = this.form.value.AnulaYSustituye;
        //model.ApellidosInspector = this.form.value.ApellidosInspector;

        model.NombreExportador = this.form.value.NombreExportador;
        model.IdPaisDestino = this.form.value.IdPaisDestino;

        model.EsPrevia = this.form.value.EsPrevia;
        model.TieneAlegacion = this.form.value.TieneAlegacion;
        model.EsEphyto = this.form.value.EsEphyto;
        model.EsPapel = this.form.value.EsPapel;
        model.EsAtestacionFitosanitaria = this.form.value.EsAtestacionFitosanitaria;

        model.EsInspector = this.isInspector;
        model.EsCoordinador = this.isCoordinador;
        model.EsSolicitante = this.isSolicitante;
        model.EsGrabador = this.isGrabador;
        model.EsAgenteControl = this.isAC;
        model.EsComunidadAutonoma = this.isCA;
        model.EsConsultas = this.isConsultas;
        model.EsConsultasySolicitante = this.isConsultas && this.isSolicitante;
        model.EsConsultasyLaboratorio = this.isConsultas && this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Laboratorio);
        model.DocumentalRealizada = this.form.value.DocumentalRealizada;

        return model;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let model: FilterSearchingSolicitudExViewModel = this.CreateModel();

        model.PageNumber = pageNumber;
        model.Asc = asc;
        model.OrderBy = orderBy;

        //Todo:agaro. 23/01/2020.
        //Establecer la hora de la fecha Hasta si tiene valor a las 23:59:59, que solo lo hace si no se selecciona y no se estaba teniendo
        //en cuenta el propio día de la fecha hasta.
        if (model.FechaHasta != null) {
            model.FechaHasta.setHours(23);
            model.FechaHasta.setMinutes(59);
            model.FechaHasta.setSeconds(59);
        }

        //BÚSQUEDA PARA COMPROBAR ESTADOS EPHYTO
        if (this.flagSearchIsComprobarEphytos) {
            this.visibilitySpinnerComprobarEphytos = true;

            this.buscadorsolicitudExService
                .comprobarEstadosEphytos(model)
                .pipe(
                    tap(result => {
                        this.resultSolicitudesEx = result;
                        this.loading = false;
                        this.visibilitySpinnerComprobarEphytos = false;
                    }),
                    catchError(error => {
                        this.catchServerError(error);
                        this.form?.disable();
                        return of(null);
                    }),
                )
                .subscribe();

            this.flagSearchIsComprobarEphytos = false;
        } //BÚSQUEDA NORMAL
        else {
            this.buscadorsolicitudExService
                .postSolicitudPagedByFilter(model)
                .pipe(
                    tap(result => {
                        this.resultSolicitudesEx = result;
                        this.loading = false;
                    }),
                    catchError(error => {
                        this.catchServerError(error);
                        this.form?.disable();
                        return of(null);
                    }),
                )
                .subscribe();
        }

        this.buscadorsolicitudExService.currentFilterSolicitudEx = model;
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link' || event.sortField == 'Image') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Codigo: '',
            NumeroCertificado: '',
            IdEstadoSolicitud: null,
            IdEstadoCertificadoFitoEx: null,
            IdPaisDestino: null,
            IdTipoSolicitudEx: null,
            IdProvincia: null,
            IdPuntoInspeccion: null,
            NombreExportador: '',
            RazonSocial: '',
            EsPrevia: EnumSiNoTodos.TODOS,
            TieneAlegacion: EnumSiNoTodos.TODOS,
            EsEphyto: EnumSiNoTodos.TODOS,
            EsPapel: EnumSiNoTodos.TODOS,
            RefSolicitante: '',
            FechaDesde: this.firstDayMonth,
            FechaHasta: this.lastDayMonth,
            IdResultadoEnvioMuestrasLaboratorioEx: null,
            TieneEnvioDeMuestras: EnumSiNoTodos.TODOS,
            EsAtestacionFitosanitaria: EnumSiNoTodos.TODOS,
            AnulaYSustituye: EnumSiNoTodos.TODOS,
            DocumentalRealizada: EnumSiNoTodos.TODOS,
        });

        this.isCollapsed = false;
        this.searchingButton = false;

        this.resultSolicitudesEx = new SolicitudExItemResultsViewModel();
    }

    onSelectPais(): void {
        // NO-OP
    }

    onSelectProvincia(): void {
        const idProvincia = this.form.value.IdProvincia;

        let params = new HttpParams();

        params = params.append('id', idProvincia?.toString() || null);
        params = params.append('esimportacion', 'false');
        this.globalService.getPuntoInspeccionByProvinciaImporExpor(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });

        this.form.patchValue({
            IdPuntoInspeccion: null,
        });
    }

    onSelectEstado(): void {
        //Si es borrador, limpiamos las fechas
        if (this.form.value.IdEstadoSolicitud == EnumIdsTcEstadoSolicitudEx.ID_BORRADOR) {
            this.form.patchValue({
                FechaDesde: null,
                FechaHasta: null,
            });
        } else {
            //Todo:agaro. Quitamos que se cambien las fechas si el estado es distinto de borrador, para no alterar los filtros.
            //if (this.form.value.FechaDesde == null || this.form.value.FechaHasta == null) {
            //    this.form.patchValue({
            //        FechaDesde: this.firstDayMonth,
            //        FechaHasta: this.lastDayMonth
            //    });
            //}
        }
    }

    checkDelete(rowData: SolicitudExItemViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.ELIMINAR_SOLICITUD_EXPORTACION, rowData.IdEstado).Visible && rowData.EsVisibleEdicion;
    }

    checkClone(rowData: SolicitudExItemViewModel): boolean {
        //Todo:agaro. 10062020. Grabador solo clonables las suyas, sobra la validación con inspector.
        if (this.isGrabador) {
            // && this.EsInspector) {
            return (
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.CLONACION_SOLICITUD_EXPORTACION, undefined, rowData.IdTipoSolicitudEx).Visible &&
                rowData.EsVisibleEdicion
            );
        } else {
            return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.CLONACION_SOLICITUD_EXPORTACION, undefined, rowData.IdTipoSolicitudEx).Visible;
        }
    }

    onEdit(item: SolicitudExViewModel): void {
        this.router.navigate(['/exportacion/solicitud/datosbasicosEx', item.Id]);
    }

    onDelete(item: SolicitudExViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de eliminar la solicitud?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.buscadorsolicitudExService.deleteSolicitud(item.Id).subscribe(() => {
                    this.addSuccessMessage('Solicitud eliminada correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    onClone(item: SolicitudExViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro de clonar esta solicitud?',
            accept: () => {
                let params = new HttpParams();

                params = params.append('idSolicitudEx', item.Id.toString());
                params = params.append('tipoSolicitudEx', item.IdTipoSolicitudEx.toString());
                //Actual logic to perform a confirmation
                this.buscadorsolicitudExService.cloneSolicitud(params).subscribe({
                    next: res => {
                        this.addSuccessMessage('Solicitud clonada correctamente');
                        let idSolicitud = res;
                        this.router.navigate(['/exportacion/solicitud/datosbasicosEx/' + idSolicitud]);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onAdd(): void {
        this.navMenuService.currentSolicitudExportacion = new SolicitudExViewModel();
        this.router.navigate(['/exportacion/solicitud/tipossolicitudesEx']);
    }

    onComprobarEstadosEphyto(): void {
        //se hace igual que en el Search normal porque los resultados aparecen en el grid y hay que hacer uso de la paginación, nº total registros encontrados, etc.
        this.flagSearchIsComprobarEphytos = true;

        if (this.turboTable) {
            this.turboTable.first = 0;
        }
        this.Search(0);
        this.searchingButton = true;
        this.isCollapsed = true;
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;
        this.buscadorsolicitudExService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    exportIsAvailable(): boolean {
        return this.resultSolicitudesEx?.ResultList ? this.resultSolicitudesEx?.ResultList?.length > 0 : false;
    }
}
